/*
 *  Products Gallery
 *    Scripts for the Products Gallery section.
 *
 *  Version:
 *    1.0.0 - 2023/07/14
 */

import $ from 'jquery';

import 'slick-carousel'
import { pictureGenerate } from '@process-creative/slate-theme-tools';
import { CarouselSection, CLASS_INITIALIZED } from './carousel/carousel-section';
import { ON_VARIANT_CHANGE } from '../objects/swatch/Swatch';
import { register } from './ShopifySection';

const CONTAINER_SELECTOR = '[data-product-gallery]';
const PRODUCT_IMAGE_SELECTOR = '[data-product-gallery-image]';

//Attrs
const IMAGE_INDEX = 'data-index';
const PRODUCT_INITIAL_VARIANT = 'data-initial-variant-id';
const ATTR_INITIAL_VARIANT_SRC = 'data-initial-variant-img-src';
const ATTR_IMAGE_ID = 'data-image-id';

export class ProductGallery extends CarouselSection {
  constructor(container) {
    super(container);

    this.initialImage = container.find(`${PRODUCT_IMAGE_SELECTOR}[${IMAGE_INDEX}="0"]`);

    //Events
    $(document).on(ON_VARIANT_CHANGE, (e,variant) => this.onVariantChange(variant));
    this.initVariantImage();
  }

  initVariantImage() {
    let initial = this.container.attr(PRODUCT_INITIAL_VARIANT);
    if(this.initialImage.attr(ATTR_IMAGE_ID) == initial) return;
    let src = this.container.attr(ATTR_INITIAL_VARIANT_SRC);
    if(src) this.updateInitialImage(src);
  }

  onVariantChange(variant) {

    let variantImage = variant.metafields.product_image;

    if (variantImage === undefined) {
      variantImage = variant.featured_image.src
    }

    if (typeof variant === typeof undefined || !variantImage) return;
    this.updateInitialImage(variantImage);
  }

  updateInitialImage(src) {

    const newImageHTML = `
    <picture>
      <img src="${src}" class="c-product-gallery__image o-responsive-image">
    </picture>
    `
  
    const imageHTMLNoCDN = newImageHTML.replace(/\/\/cdn.shopify.com/g, '');
  
    // Create a new image element
    const newImage = $(newImageHTML);
    const newImageSrc = newImage.find('img');
  
    // Hide the new image initially
    newImage.css('opacity', 0);
  
    // Insert the new image as a sibling next to the initial image
    this.initialImage.after(newImage);
  
    // Trigger a reflow to ensure the transition works
    this.initialImage[0].offsetWidth; // This is a hack to trigger a reflow
  
    newImageSrc.on('load', () => {
      newImage.css('transition', 'opacity 1s');
      newImage.css('opacity', 1);
      this.setInitialImage(newImage);
    });
  }
  
  setInitialImage(newImage) {
    setTimeout(() => {
      this.initialImage.remove();
      this.initialImage = newImage;
    }, 1000);
  }
  
}

register(CONTAINER_SELECTOR, ProductGallery);